import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import '@/assets/custom.css'

import VueSocketIOExt from 'vue-socket.io-extended';
const io = require('socket.io-client');

const socket = io(process.env.VUE_APP_SOCKET_HOST, {
  autoConnect: false,
});``

socket.on('connection_authentication', function (dataIN, callback) {
  callback("varun", "123456", process.env.VUE_APP_SOCKET_USER);  // midgam.voip  askaria.voip
})



if(localStorage.getItem('user'))  {
  socket.open();
}

/*
  function handleSocketData(data) {
    var data1 = JSON.stringify(data);
    var json = JSON.parse(data1);
  //var onRing = OnRingTMP;
  //var onRing = onAnswerTMP;
  console.log(json);
  switch (json.event){
    case ("PeerStatus") :
      if (json.peerstatus == "Unreachable"){
        // Do your stuff here
      }
      /*if ((json.peerstatus == "Registered" || json.peerstatus == "Reachable") &&  !$('.' + exten).hasClass("inuse")  &&  !$('.' + exten).hasClass("busy")  &&  !$('.' + exten).hasClass("onhold") &&  !$('.' + exten).hasClass("ring") &&  !$('.' + exten).hasClass("idle") ){
        // Do your stuff here
      } */  /*
    break;
  //  ****************  end PeerStatus  ******************
    case ("ExtensionStatus"):
  //      console.log(data1);
      if (json.status == "0") {

      }
      else if (json.status == "1") {

      }
      else if (json.status == '2') {

      }
      else if (json.status == '4') {

      }
      else if (json.status == "8") { //Ringing

      }
      else if (json.status == "16") {

      }
    break;

    case ("Newstate") :

//   *** Ringing ****
      if (json.channelstatedesc == "Ringing") {

      }

      if (json.channelstatedesc == "Ring") {
      }

//   *** Call answered ***
      if (json.channelstatedesc == "Up") {

      }
    break;

//  *** Call Hangup ****
    case ("Hangup"):


    break;


  }
  }

  socket.on('connection_initialized', function (data) {
    console.log("initialized data --->>", data);
    for (event in data) {
      handleSocketData(data[event]);
    }
  })

  socket.on('BLB_event', handleSocketData);
*/

Vue.use(VueSocketIOExt, socket, { store });

import BootstrapVue from 'bootstrap-vue'
Vue.use(BootstrapVue)

import VueIframe from 'vue-iframes'
Vue.use(VueIframe)

import notie from 'notie'
import 'notie/dist/notie.css'
window.notie = notie;

import dict_en from '../../public/js/lang/en.js';
import dict_he from '../../public/js/lang/he.js';
window.dict_en = dict_en;
window.dict_he = dict_he;

import {_t, setDict} from './utils/i18n'
let curLang = localStorage.getItem('uiLang');
if(!curLang) {
  curLang = 'en'
  localStorage.setItem('uiLang', 'en')
}
setDict(window['dict_'+curLang]);
window._t = _t;
window.setDict = setDict;
Vue.prototype.$t = _t;
Vue.prototype.$setDict = setDict;

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
